import { useInjection } from 'inversify-react';
import { observer } from 'mobx-react-lite';
import { ReactElement, useState } from 'react';
import { answerQuestion } from '../../../../annotation/question.model';
import { useProjectDetailsPermissions } from '../../../projectDetails.permissions';
import { BatchAnswerQuestions } from '../components/BatchAnswerQuestions';
import { IProjectDetailsImagesBl } from '../projectDetailsImages.bl';
import { IProjectDetailsImagesStore } from '../projectDetailsImages.store';

export const BatchAnswerQuestionsContainer = observer((): ReactElement => {
  const permissions = useProjectDetailsPermissions();
  const projectDetailsImagesBl = useInjection(IProjectDetailsImagesBl.$);
  const imagesStore = useInjection(IProjectDetailsImagesStore.$);

  const [showModal, setShowModal] = useState(false);

  const handleSubmitAsync = async (): Promise<void> => {
    await projectDetailsImagesBl.batchAnswerQuestionsAsync();
  };

  const handleModalShow = (): void => {
    setShowModal(true);
    projectDetailsImagesBl.toggleAnswerQuestionsModal();
  };

  const handleModalClose = (): void => {
    setShowModal(false);
    projectDetailsImagesBl.toggleAnswerQuestionsModal();
  };

  const handleAnswer = (questionId: string, answer: string): void => {
    const question = imagesStore.questions.find((x) => x.id === questionId);

    if (question) {
      answerQuestion(question, answer);
    }
  };

  const {
    toggledImages,
    selectionMode,
    imagesPaging,
    questions,
    batchAnswerBatchesCount,
    batchAnswerFailedBatches,
    batchAnswerSuccessfulBatches,
    batchAnswerQuestionsError,
    batchAnswerQuestionsRequestInProgress,
  } = imagesStore;

  const projectHasNoQuestions = questions.length === 0;

  const disabled =
    (selectionMode === 'Select' && toggledImages.length === 0) ||
    (selectionMode === 'Deselect' && toggledImages.length === imagesPaging.totalCount) ||
    projectHasNoQuestions;

  if (!permissions.canBatchAnswer().allowed) {
    return <></>;
  }

  return (
    <BatchAnswerQuestions
      batchAnswerBatchesCount={batchAnswerBatchesCount}
      batchAnswerFailedBatches={batchAnswerFailedBatches}
      batchAnswerQuestionsModalError={batchAnswerQuestionsError}
      batchAnswerQuestionsRequestInProgress={batchAnswerQuestionsRequestInProgress}
      batchAnswerSuccessfulBatches={batchAnswerSuccessfulBatches}
      disabled={disabled}
      isModalOpen={showModal}
      projectHasNoQuestions={projectHasNoQuestions}
      questions={questions}
      onAnswered={handleAnswer}
      onSubmit={handleSubmitAsync}
      onModalClose={handleModalClose}
      onModalShow={handleModalShow}
    />
  );
});
